import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import { withPropsOnChange } from 'recompose';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import FontIcon from '../../atoms/FontIcon';
import ActionMenu from '../actionMenu';
import VisibleActions from './molecules/visibleActions';

// Helpers
import { mapPropsToActionsListProps } from './ActionsList.helper';
var PROPS_TO_WATCH = ['actions', 'visibleActionCount'];
var ActionsList = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionsList, _PureComponent);
  var _super = _createSuper(ActionsList);
  function ActionsList() {
    var _this;
    _classCallCheck(this, ActionsList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderHiddenActions", function () {
      var _this$props = _this.props,
        hiddenActions = _this$props.hiddenActions,
        onActionClick = _this$props.onActionClick,
        placement = _this$props.placement,
        align = _this$props.align,
        showTooltip = _this$props.showTooltip;
      return /*#__PURE__*/React.createElement(ActionMenu, {
        actions: hiddenActions,
        onActionClick: onActionClick,
        placement: placement,
        align: align,
        showTooltip: showTooltip
      }, /*#__PURE__*/React.createElement("div", {
        className: "full-height flex-center cursor-pointer"
      }, /*#__PURE__*/React.createElement(FontIcon, {
        "data-disable-sort-start": true
      }, "icon-overflow")));
    });
    return _this;
  }
  _createClass(ActionsList, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        visibleActions = _this$props2.visibleActions,
        hiddenActions = _this$props2.hiddenActions,
        className = _this$props2.className,
        onActionClick = _this$props2.onActionClick,
        visibleActionsClassName = _this$props2.visibleActionsClassName;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement(VisibleActions, {
        actions: visibleActions,
        onActionClick: onActionClick,
        visibleActionsClassName: visibleActionsClassName
      }), !_isEmpty(hiddenActions) && this.renderHiddenActions());
    }
  }]);
  return ActionsList;
}(PureComponent);
ActionsList.propTypes /* remove-proptypes */ = {
  visibleActions: VisibleActions.propTypes.actions.isRequired,
  hiddenActions: ActionMenu.propTypes.actions,
  onActionClick: PropTypes.func,
  className: PropTypes.string,
  align: PropTypes.object,
  visibleActionsClassName: PropTypes.string
};
ActionsList.defaultProps = {
  hiddenActions: EMPTY_ARRAY,
  onActionClick: noop,
  className: '',
  align: EMPTY_OBJECT,
  visibleActionsClassName: undefined
};
export var withActionsListProps = withPropsOnChange(PROPS_TO_WATCH, mapPropsToActionsListProps);
var WrappedActionsList = withActionsListProps(ActionsList);
WrappedActionsList.propTypes /* remove-proptypes */ = {
  actions: ActionMenu.propTypes.actions.isRequired,
  visibleActionCount: PropTypes.number,
  onActionClick: PropTypes.func
};
export default WrappedActionsList;